<div *ngIf="hasValues()" class="property-values-container">
  <div class="property-values-table">
    <table class="values-table">
      <thead>
        <tr>
          <th>{{ "SHARED.Property_Name" | translate }}</th>
          <th>{{ "MGMT_DETAILS.Value" | translate }}</th>
          <th>{{ "SHARED.Captured_Time" | translate }}</th>
          <th>{{ "SHARED.Captured_By" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of collectedValues" class="value-row">
          <td class="property-name">{{ item.propertyName }}</td>
          <td class="property-value">
            <span *ngIf="!isInServiceProperty(item)">{{ item.displayValue }}</span>
            <span *ngIf="isInServiceProperty(item)" 
                  class="badge-label {{ getInServiceStatus(item)?.type }}">
              {{ getInServiceStatus(item)?.title | translate }}
            </span>
          </td>
          <td class="property-time">{{ item.timeFormatted }}</td>
          <td class="property-user">{{ item.userName }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div *ngIf="!hasValues()" class="no-properties-message">
  <p>{{ "PROPERTY.No_Properties_Collected" | translate }}</p>
</div>
